








































































































































































































































































































































































import Vue from "vue";
import _ from "lodash";
import AdvertisementForm from "../../components/Form/AdvertisementForm.vue";
import { Advertisement } from "@/interfaces/advertisement";
import { AdvertiserEntry } from "@/interfaces/advertiserentry";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Api from "@/api/Api";
import { PublishmentRegion } from "@/interfaces/publishmentregion";
import { PublishmentLocality } from "@/interfaces/publishmentlocality";
import { mapActions, mapState } from "vuex";
export default Vue.extend({
  components: {
    //ImageUpload,
    AdvertisementForm
  },
  async mounted() {
    this.isLoading = false;
    const api = Api.singleton();
    await api.jwtToken.tryLoadJwtToken();
    if (api.jwtToken.isGranted(["ROLE_ADVERTISER"])) {
      this.$router.push({
        name: "Login"
      });
    }
    this.fetchPrefectures();
    this.loadRegions();
    this.loadLocalities();
  },
  data() {
    return {
      inputs: {
        advertisement: {
          input: {} as Advertisement,
          files: {
            image1: undefined,
            image2: undefined,
            image3: undefined,
            image4: undefined,
            image5: undefined
          } as { [key: string]: File | undefined }
        },
        advertiserEntry: {
          input: {} as AdvertiserEntry
        },
        publishmentOrder: {
          input: {} as PublishmentOrder
        }
      } as { [key: string]: any },
      errors: {
        advertisement: {},
        advertiserEntry: {},
        publishmentOrder: {}
      },
      isLoading: true,
      phase: "input"
    };
  },
  methods: {
    ...mapActions(["loadRegions", "loadLocalities", "fetchPrefectures"]),
    async confirm() {
      this.errors = {
        advertisement: {},
        advertiserEntry: {},
        publishmentOrder: {}
      };
      this.isLoading = true;
      let hasError = false;

      // 広告のバリデート
      {
        const postData: Record<string, unknown> = {};
        for (const [k, v] of Object.entries(this.inputs.advertisement.input)) {
          if (_.isPlainObject(v) && (v as { "@id": string })["@id"]) {
            postData[k] = (v as { "@id": string })["@id"];
          } else {
            postData[k] = v;
          }
        }

        try {
          const decorated = await this.decoratePostData(postData);
          await Api.singleton().call({
            method: "post",
            resource: "/api/adv/posts/validate_trial",
            body: decorated
          });
        } catch (violations) {
          for (const v of violations as {
            propertyPath: string;
            message: string;
          }[]) {
            this.$set(this.errors.advertisement, v.propertyPath, v.message);
          }
          hasError = true;
        }
      }
      // 広告主のバリデート
      {
        const postData: Record<string, unknown> = {};
        for (const [k, v] of Object.entries(
          this.inputs.advertiserEntry.input
        )) {
          if (_.isPlainObject(v) && (v as { "@id": string })["@id"]) {
            postData[k] = (v as { "@id": string })["@id"];
          } else {
            postData[k] = v;
          }
        }

        try {
          const decorated = postData;
          await Api.singleton().call({
            method: "POST",
            resource: "/api/adv/advertiser_entries/validate_trial",
            body: decorated
          });
        } catch (violations) {
          for (const v of violations as {
            propertyPath: string;
            message: string;
          }[]) {
            this.$set(this.errors.advertiserEntry, v.propertyPath, v.message);
          }
          hasError = true;
        }
      }
      // // 掲載先のバリデート
      // {
      //   const postData: Record<string, unknown> = {};
      //   for (const [k, v] of Object.entries(
      //     this.inputs.publishmentOrder.input
      //   )) {
      //     if (_.isPlainObject(v) && (v as { "@id": string })["@id"]) {
      //       postData[k] = (v as { "@id": string })["@id"];
      //     } else {
      //       postData[k] = v;
      //     }
      //   }

      //   try {
      //     const decorated = postData;
      //     decorated.paymentType = "trial";
      //     await Api.singleton().call({
      //       method: "POST",
      //       resource: "/api/adv/publishment_orders/validate_trial",
      //       body: decorated
      //     });
      //   } catch (violations) {
      //     for (const v of violations as {
      //       propertyPath: string;
      //       message: string;
      //     }[]) {
      //       this.$set(this.errors.publishmentOrder, v.propertyPath, v.message);
      //     }
      //     hasError = true;
      //   }
      // }
      if (hasError) {
        (
          document.getElementsByClassName("main")[0] || document.body
        ).scrollIntoView({
          behavior: "auto",
          block: "start"
        });
      } else {
        // email重複のチェック
        try {
          await Api.singleton().call({
            method: "POST",
            resource: "/api/adv/advertiser_entries/validate_email",
            body: { email: this.inputs.advertiserEntry.input.email }
          });
        } catch (violations) {
          this.$router.push({
            name: "TrialError"
          });
        }

        this.phase = "confirm";
      }
      this.isLoading = false;
    },
    async exec() {
      const decorated = {} as {
        [key: string]: any,
        advertisement: Advertisement | undefined;
        advertiserEntry: AdvertiserEntry | undefined;
        publishmentOrder: PublishmentOrder | undefined;
      };
      for (const dataKey of [
        "advertisement",
        "advertiserEntry",
        "publishmentOrder"
      ]) {
        const postData: { [key: string]: unknown } = {};
        for (const [k, v] of Object.entries(this.inputs[dataKey].input)) {
          if (_.isPlainObject(v) && (v as any)["@id"]) {
            postData[k] = (v as any)["@id"];
          } else {
            postData[k] = v;
          }
        }
        decorated[dataKey] = await this.decoratePostData(postData);
      }

      try {
        const ret = await this.$store.dispatch("post", [
          "/api/adv/posts/create_trial",
          decorated
        ]);
        this.$router.push({
          name: "TrialComplete",
          params: { id: ret.id }
        });
      } catch (ex) {
        alert("登録時にエラーが発生しました");
      }
      this.isLoading = false;
    },
    async decoratePostData(this: any, postData: Record<string, unknown>) {
      const fileViolations = [];
      for (const [key, file] of Object.entries(
        this.$refs.advertisementForm.files
      )) {
        if (file) {
          try {
            const ret = await this.$store.dispatch("uploadFile", file);
            postData[key] = ret["@id"];
            this.$set(this.inputs.advertisement.input, key, ret);
          } catch (violations) {
            console.error(violations);
            // this.$delete(this.advertisement, key);
            for (const v of violations as {
              propertyPath: string;
              message: string;
            }[]) {
              fileViolations.push({ propertyPath: key, message: v.message });
            }
          }
          this.$refs.advertisementForm[key] = undefined;
        }
      }
      if (fileViolations.length) {
        throw fileViolations;
      }
      postData["eyeCatch"] = postData["image" + postData["eyecatchIndex"]];
      postData["owner"] = this.$store.getters.my().advertiser;

      delete postData.publicAdvertisement;
      delete postData.publishmentOrder;

      return postData;
    }
  },
  computed: {
    ...mapState(["prefectures", "regions", "localities"]),
    _() {
      return _;
    },
    isPage() {
      return true;
    },
    selectableRegions(): PublishmentRegion[] {
      const selectableIdx = {} as Record<number, boolean>;
      for (const l of this.localities) {
        selectableIdx[l.region.id] = true;
      }
      const selectable = [] as PublishmentRegion[];
      for (const r of this.regions) {
        if (r.id in selectableIdx) {
          selectable.push(r);
        }
      }

      return selectable;
    },
    selectableLocalities(): PublishmentLocality[] {
      const selectable = [] as PublishmentLocality[];
      for (const l of this.localities) {
        if (l.region.id == this.inputs.publishmentOrder.input.region?.id) {
          selectable.push(l);
        }
      }
      return selectable;
    },
    threeDaysAfter(): Date {
      const d = new Date();
      d.setDate(d.getDate() + 2);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);

      return d;
    },
    hasErrors(): boolean {
      return (
        !_.isEmpty(this.errors.advertisement) ||
        !_.isEmpty(this.errors.advertiserEntry) ||
        !_.isEmpty(this.errors.publishmentOrder)
      );
    }
  }
});
